// import OrderTable from '../components/OrderTable';
import { toast } from 'react-toastify';
import { useInvoices, useInvoiceSearchParams } from '../store/invoices';

import { useEffect } from "react";
import InvoiceTable from '../components/InvoiceTable';
import { socketEmit, SocketRPC } from "../lib/socket";
import useProducerLocations from '../store/producer-locations';
import useUser from "../store/user";

const InvoicePage = () => {

    const {user} = useUser();
    const { producerKey, orderSourceKey, partnerKey } = user || {};
    const { invoices, setInvoices, invoicesLoaded, setInvoicesLoaded } = useInvoices();
    const { invoiceSearchParams, setInvoiceSearchParams, activePage, setActivePage } = useInvoiceSearchParams();
	const {producerLocations, setProducerLocations} = useProducerLocations();

	useEffect(() => {

		if (!producerKey) return;
		if (producerLocations && producerLocations.length > 0) return;

		Promise.resolve()
			.then(() => {
				return socketEmit(SocketRPC.GetProducerLocations, { producerKey });
			})
			.then((res) => {
				if (!res.success) {
					throw new Error(res.error);
				}
				setProducerLocations(res.producerLocations);
			})
	}, []);

    useEffect(() => {
		setInvoicesLoaded(false);
		Promise.resolve()
			.then(() => {
				return socketEmit(SocketRPC.SearchInvoices, {
					...(invoiceSearchParams || {}),
					user,
					producerKey,
					orderSourceKey,
					partnerKey,
					pageIndex: activePage - 1,
					pageSize: 10,
				});
			})
			.then((res) => {
				if (!res.success) {
					setInvoices([]);
					throw new Error(res.error);
				}
				setInvoices(res.invoices);
				setInvoicesLoaded(true);
			})
			.catch((err) => {
				toast.error(`Error searching refunds. Please try again`);
				setInvoicesLoaded(true);
				console.log(`Could not search refunds`, err);
			});
	}, [JSON.stringify(invoiceSearchParams), activePage]);

	const paginationProps = {
		activePage,
		setActivePage,
	};

	const InvoiceTableProps = {
		invoices,
		invoicesLoaded,
		setInvoiceSearchParams,
		invoiceSearchParams,
		paginationProps,
		producerLocations,
	};

	return InvoiceTable(InvoiceTableProps);
};

export default InvoicePage;
